// ArchiveIcon.jsx

import React from 'react';

/**
 * ArchiveIcon
 *
 * @returns {ReactNode} The rendered component.
 */
const ArchiveIcon = React.memo(({ width = 24, height = 24, ...rest }) => {

  // ----- RENDER ----- //

  return (
  <svg
    width={width}
    height={height}
    viewBox="0 0 64 64"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    focusable="false"
    {...rest}
  >
    <path opacity="0.2" d="M14.5 8C13.115 8 12 9.115 12 10.5v45c0 1.385 1.115 2.5 2.5 2.5h35c1.385 0 2.5-1.115 2.5-2.5V23L38.25 21.75 37 8z" />
    <path fill="#cfa94c" d="m14.5 7c-1.385 0-2.5 1.115-2.5 2.5v45c0 1.385 1.115 2.5 2.5 2.5h35c1.385 0 2.5-1.115 2.5-2.5v-32.5l-13.75-1.25-1.25-13.75z" />
    <path opacity="0.2" d="m37 8v12.5c0 1.3808 1.1193 2.5 2.5 2.5H52z" />
    <path fill="#f0c75b" d="m37 7v12.5c0 1.3808 1.1193 2.5 2.5 2.5h12.5l-15-15z" />
    <path opacity="0.2" d="m32 32c-2.210666 0-4 1.8-4 4v8c0 2.2 1.79 4 4 4 2.21 0 4-1.8 4-4v-8c0-2.2-1.789334-4-4-4zm0 2c1.104 0 2 0.8 2 2 0 .999998-.896 2-2 2-1.104 0-2-1.000002-2-2 0-1.2.896-2 2-2zm0 6c1.10457 0 2 .89543 2 2v2c0 1.10457-.89543 2-2 2-1.10457 0-2-.89543-2-2v-2c0-1.10457.89543-2 2-2z" />
    <path opacity="0.2" d="M30 7v22c0 1.1.895 2 2 2s2-.9 2-2V7z" />
    <path opacity="0.2" d="M31 12v1h1v-1zm1 1v1h1v-1zm0 1h-1v1h1zm0 1v1h1v-1zm0 1h-1v1h1zm0 1v1h1v-1zm0 1h-1v1h1zm0 1v1h1v-1zm0 1h-1v1h1zm0 1v1h1v-1z" />
    <path fill="#dddddd" d="M31 13v1h1v-1zm0 2v1h1v-1zm0 2v1h1v-1zm0 2v1h1v-1zm0 2v1h1v-1z" />
    <path opacity="0.2" d="M31 23h1c.04125-.367529 0-1 0-1h-1zm1 0v1h1v-1zm0 1h-1v1h1zm0 1v1h1v-1zm0 1h-1v1h1zm0 1v1h1v-1zm0 1h-1v1h1zm0 1v1h1v-1zm0 1h-1c-.04374.389771 0 1 0 1h1c0 0 0-.52979 0-1z" />
    <path fill="#dddddd" d="M31 23v1h1v-1zm0 2v1h1v-1zm0 2v1h1v-1zm0 2v1h1v-1z" />
    <path fill="#ffffff" d="m32 31c-2.210666 0-4 1.8-4 4v8c0 2.2 1.79 4 4 4 2.21 0 4-1.8 4-4v-8c0-2.2-1.789334-4-4-4zm0 2c1.104 0 2 .8 2 2 0 .999998-.896 2-2 2-1.104 0-2-1.000002-2-2 0-1.2.896-2 2-2zm0 6c1.10457 0 2 .89543 2 2v2c0 1.10457-.89543 2-2 2-1.10457 0-2-.89543-2-2v-2c0-1.10457.89543-2 2-2z" />
    <path opacity="0.2" fill="#ffffff" d="M14.5 7C13.115 7 12 8.115 12 9.5v1C12 9.115 13.115 8 14.5 8H37V7z" />
    <path fill="#dddddd" d="M31 7v1h1V7zm0 2v1h1V9zm0 2v1h1v-1z" />
    <path opacity="0.2" d="M32 7v1h1V7zm0 1h-1v1h1zM32 9v1h1V9zm0 1h-1v1h1zM32 11v1h1v-1z" />
  </svg>
  );
});

// Dev Tools
ArchiveIcon.displayName = 'ArchiveIcon';

export default ArchiveIcon;
